function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "canvas__node_icon_svgFlow-shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.02564 4.58975C2.02564 6.57231 3.63282 8.17949 5.61538 8.17949H10.2308V17.702C4.94992 18.8701 1 23.5798 1 29.2119C1 35.7223 6.27769 41 12.788 41C19.2984 41 24.5761 35.7223 24.5761 29.2119C24.5761 23.5846 20.633 18.8782 15.359 17.7051V8.17949H19.9743C21.9569 8.17949 23.5641 6.57231 23.5641 4.58975C23.5641 2.60719 21.9569 1.00001 19.9743 1.00001H5.61538C3.63282 1.00001 2.02564 2.60719 2.02564 4.58975Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2308 8.17949H11.2308C11.2308 7.6272 10.783 7.17949 10.2308 7.17949V8.17949ZM10.2308 17.702L10.4467 18.6784C10.9047 18.5771 11.2308 18.1711 11.2308 17.702H10.2308ZM15.359 17.7051H14.359C14.359 18.1737 14.6844 18.5795 15.1418 18.6812L15.359 17.7051ZM15.359 8.17949V7.17949C14.8067 7.17949 14.359 7.6272 14.359 8.17949H15.359ZM5.61538 7.17949C4.1851 7.17949 3.02564 6.02002 3.02564 4.58975H1.02564C1.02564 7.12459 3.08053 9.17949 5.61538 9.17949V7.17949ZM10.2308 7.17949H5.61538V9.17949H10.2308V7.17949ZM9.23075 8.17949V17.702H11.2308V8.17949H9.23075ZM10.0148 16.7256C4.28575 17.9929 0 23.1007 0 29.2119H2C2 24.0588 5.61409 19.7474 10.4467 18.6784L10.0148 16.7256ZM0 29.2119C0 36.2746 5.7254 42 12.788 42V40C6.82997 40 2 35.17 2 29.2119H0ZM12.788 42C19.8507 42 25.5761 36.2746 25.5761 29.2119H23.5761C23.5761 35.17 18.7461 40 12.788 40V42ZM25.5761 29.2119C25.5761 23.106 21.2977 18.0016 15.5761 16.7289L15.1418 18.6812C19.9682 19.7548 23.5761 24.0632 23.5761 29.2119H25.5761ZM16.359 17.7051V8.17949H14.359V17.7051H16.359ZM19.9743 7.17949H15.359V9.17949H19.9743V7.17949ZM22.5641 4.58975C22.5641 6.02002 21.4046 7.17949 19.9743 7.17949V9.17949C22.5092 9.17949 24.5641 7.12459 24.5641 4.58975H22.5641ZM19.9743 2.00001C21.4046 2.00001 22.5641 3.15947 22.5641 4.58975H24.5641C24.5641 2.05491 22.5092 6.19888e-06 19.9743 6.19888e-06V2.00001ZM5.61538 2.00001H19.9743V6.19888e-06H5.61538V2.00001ZM3.02564 4.58975C3.02564 3.15947 4.18511 2.00001 5.61538 2.00001V6.19888e-06C3.08053 6.19888e-06 1.02564 2.0549 1.02564 4.58975H3.02564Z",
  fill: "#373A3C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "canvas__node_icon_svgFlow-outline-thick",
  d: "M11.2308 9.17948H13.2308C13.2308 8.07491 12.3353 7.17948 11.2308 7.17948V9.17948ZM11.2308 18.702L11.6627 20.6548C12.5787 20.4522 13.2308 19.6402 13.2308 18.702H11.2308ZM16.359 18.7051H14.359C14.359 19.6423 15.0098 20.4538 15.9247 20.6573L16.359 18.7051ZM16.359 9.17948V7.17948C15.2544 7.17948 14.359 8.07491 14.359 9.17948H16.359ZM6.61538 7.17948C5.73739 7.17948 5.02564 6.46773 5.02564 5.58974H1.02564C1.02564 8.67687 3.52825 11.1795 6.61538 11.1795V7.17948ZM11.2308 7.17948H6.61538V11.1795H11.2308V7.17948ZM9.23075 9.17948V18.702H13.2308V9.17948H9.23075ZM10.7988 16.7492C4.62158 18.1156 0 23.6217 0 30.2119H4C4 25.5378 7.27826 21.6246 11.6627 20.6548L10.7988 16.7492ZM0 30.2119C0 37.8269 6.17312 44 13.788 44V40C8.38226 40 4 35.6177 4 30.2119H0ZM13.788 44C21.403 44 27.5761 37.8269 27.5761 30.2119H23.5761C23.5761 35.6177 19.1938 40 13.788 40V44ZM27.5761 30.2119C27.5761 23.6273 22.9624 18.125 16.7932 16.7528L15.9247 20.6573C20.3035 21.6314 23.5761 25.5418 23.5761 30.2119H27.5761ZM18.359 18.7051V9.17948H14.359V18.7051H18.359ZM20.9743 7.17948H16.359V11.1795H20.9743V7.17948ZM22.5641 5.58974C22.5641 6.46773 21.8523 7.17948 20.9743 7.17948V11.1795C24.0615 11.1795 26.5641 8.67687 26.5641 5.58974H22.5641ZM20.9743 4C21.8523 4 22.5641 4.71175 22.5641 5.58974H26.5641C26.5641 2.50262 24.0615 0 20.9743 0V4ZM6.61538 4H20.9743V0H6.61538V4ZM5.02564 5.58974C5.02564 4.71175 5.73739 4 6.61538 4V0C3.52825 0 1.02564 2.50261 1.02564 5.58974H5.02564Z",
  fill: "#373A3C"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: -3,
  y1: -2,
  x2: -3,
  y2: 38
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: -3,
  y1: -2,
  x2: 28,
  y2: -2
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: 28,
  y1: -2,
  x2: 28,
  y2: 38
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "node_flow_point",
  cx: 0,
  cy: 29,
  r: 2
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "node_flow_point",
  cx: 26,
  cy: 29,
  r: 2
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "node_center",
  cx: 13,
  cy: 29,
  r: 2
});

var SvgRegulator = function SvgRegulator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "canvas__node_icon_svgFlow",
    width: 26,
    height: 42,
    viewBox: "0 0 26 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegulator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/regulator.e14907d0.svg";
export { ForwardRef as ReactComponent };